import { render } from "./CampaignsList.vue?vue&type=template&id=3db1f7ea&scoped=true"
import script from "./CampaignsList.vue?vue&type=script&lang=js"
export * from "./CampaignsList.vue?vue&type=script&lang=js"

import "./CampaignsList.vue?vue&type=style&index=0&id=3db1f7ea&lang=scss&scoped=true"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db1f7ea"]])

export default __exports__